import { useState } from "react";
import { Link } from "react-router-dom";
import { X, BookOpen, Info } from "lucide-react";

// Symbol renderer — schematic SVG glyphs. Each is a 28x28 piece centered at (cx, cy).
export function Symbol({ type, cx, cy, active }) {
  const stroke = active ? "#dc2626" : "#18181b";
  const fill = active ? "#fef2f2" : "#fff";
  const sw = 1.6;
  switch (type) {
    case "FACU":
      return (
        <g>
          <rect x={cx - 14} y={cy - 14} width="28" height="28" fill="#18181b" stroke={stroke} strokeWidth={sw} />
          <text x={cx} y={cy + 1} fontSize="7" fontFamily="monospace" fontWeight="bold" fill="#fff" textAnchor="middle" dominantBaseline="middle">FACU</text>
        </g>
      );
    case "smoke":
    case "addressable-detector":
      return (
        <g>
          <circle cx={cx} cy={cy} r={11} fill={fill} stroke={stroke} strokeWidth={sw} />
          <text x={cx} y={cy + 1} fontSize="9" fontFamily="monospace" fontWeight="bold" fill={stroke} textAnchor="middle" dominantBaseline="middle">S</text>
        </g>
      );
    case "duct-detector":
      return (
        <g>
          <rect x={cx - 11} y={cy - 8} width="22" height="16" fill={fill} stroke={stroke} strokeWidth={sw} />
          <text x={cx} y={cy + 1} fontSize="7" fontFamily="monospace" fontWeight="bold" fill={stroke} textAnchor="middle" dominantBaseline="middle">DD</text>
        </g>
      );
    case "heat":
      return (
        <g>
          <rect x={cx - 11} y={cy - 11} width="22" height="22" fill={fill} stroke={stroke} strokeWidth={sw} transform={`rotate(45 ${cx} ${cy})`} />
          <text x={cx} y={cy + 1} fontSize="9" fontFamily="monospace" fontWeight="bold" fill={stroke} textAnchor="middle" dominantBaseline="middle">H</text>
        </g>
      );
    case "pull":
      return (
        <g>
          <rect x={cx - 10} y={cy - 11} width="20" height="22" fill="#dc2626" stroke="#7f1d1d" strokeWidth={sw} />
          <text x={cx} y={cy + 1} fontSize="9" fontFamily="monospace" fontWeight="bold" fill="#fff" textAnchor="middle" dominantBaseline="middle">P</text>
        </g>
      );
    case "horn-strobe":
      return (
        <g>
          <rect x={cx - 12} y={cy - 8} width="24" height="16" fill={fill} stroke={stroke} strokeWidth={sw} rx="2" />
          <text x={cx} y={cy + 1} fontSize="7" fontFamily="monospace" fontWeight="bold" fill={stroke} textAnchor="middle" dominantBaseline="middle">H/S</text>
        </g>
      );
    case "strobe":
      return (
        <g>
          <polygon points={`${cx - 11},${cy - 9} ${cx + 11},${cy - 9} ${cx + 6},${cy + 9} ${cx - 6},${cy + 9}`} fill={fill} stroke={stroke} strokeWidth={sw} />
          <text x={cx} y={cy + 1} fontSize="8" fontFamily="monospace" fontWeight="bold" fill={stroke} textAnchor="middle" dominantBaseline="middle">V</text>
        </g>
      );
    case "speaker":
      return (
        <g>
          <circle cx={cx} cy={cy} r={11} fill={fill} stroke={stroke} strokeWidth={sw} />
          <text x={cx} y={cy + 1} fontSize="8" fontFamily="monospace" fontWeight="bold" fill={stroke} textAnchor="middle" dominantBaseline="middle">SPK</text>
        </g>
      );
    case "sprinkler-flow":
      return (
        <g>
          <circle cx={cx} cy={cy} r={11} fill="#3b82f6" stroke={stroke} strokeWidth={sw} />
          <text x={cx} y={cy + 1} fontSize="9" fontFamily="monospace" fontWeight="bold" fill="#fff" textAnchor="middle" dominantBaseline="middle">F</text>
        </g>
      );
    case "sprinkler-tamper":
      return (
        <g>
          <rect x={cx - 11} y={cy - 11} width="22" height="22" fill="#fde68a" stroke="#a16207" strokeWidth={sw} />
          <text x={cx} y={cy + 1} fontSize="9" fontFamily="monospace" fontWeight="bold" fill="#78350f" textAnchor="middle" dominantBaseline="middle">T</text>
        </g>
      );
    case "NAC-booster":
      return (
        <g>
          <rect x={cx - 13} y={cy - 11} width="26" height="22" fill="#18181b" stroke={stroke} strokeWidth={sw} />
          <text x={cx} y={cy + 1} fontSize="7" fontFamily="monospace" fontWeight="bold" fill="#fff" textAnchor="middle" dominantBaseline="middle">PSE</text>
        </g>
      );
    case "module-input":
      return (
        <g>
          <rect x={cx - 11} y={cy - 11} width="22" height="22" fill={fill} stroke={stroke} strokeWidth={sw} />
          <text x={cx} y={cy + 1} fontSize="8" fontFamily="monospace" fontWeight="bold" fill={stroke} textAnchor="middle" dominantBaseline="middle">M</text>
        </g>
      );
    case "module-output":
      return (
        <g>
          <rect x={cx - 11} y={cy - 11} width="22" height="22" fill={fill} stroke={stroke} strokeWidth={sw} strokeDasharray="3 2" />
          <text x={cx} y={cy + 1} fontSize="8" fontFamily="monospace" fontWeight="bold" fill={stroke} textAnchor="middle" dominantBaseline="middle">R</text>
        </g>
      );
    case "BDA":
      return (
        <g>
          <rect x={cx - 13} y={cy - 9} width="26" height="18" fill="#18181b" stroke={stroke} strokeWidth={sw} />
          <text x={cx} y={cy + 1} fontSize="7" fontFamily="monospace" fontWeight="bold" fill="#fff" textAnchor="middle" dominantBaseline="middle">BDA</text>
        </g>
      );
    case "supervising-station":
      return (
        <g>
          <rect x={cx - 22} y={cy - 14} width="44" height="28" fill="#18181b" stroke={stroke} strokeWidth={sw} />
          <text x={cx} y={cy - 2} fontSize="6" fontFamily="monospace" fontWeight="bold" fill="#fff" textAnchor="middle" dominantBaseline="middle">CENTRAL</text>
          <text x={cx} y={cy + 6} fontSize="6" fontFamily="monospace" fontWeight="bold" fill="#fff" textAnchor="middle" dominantBaseline="middle">STATION</text>
        </g>
      );
    default:
      return null;
  }
}

export const RiserDiagram = ({ diagram, freeMode = false }) => {
  const [selected, setSelected] = useState(null);
  const FLOOR_H = 90;
  const PAD_X = 56;
  const W = 720;
  const H = diagram.floors.length * FLOOR_H + 90;

  return (
    <div className="card-tech bg-white p-4 sm:p-6" data-testid={`riser-diagram-${diagram.id}`}>
      <div className="flex items-start justify-between gap-4 mb-3 flex-wrap">
        <div>
          <div className="overline mb-1"><span className="red-bar" />{diagram.nicet}</div>
          <h3 className="font-heading text-2xl font-bold tracking-tight" data-testid={`riser-title-${diagram.id}`}>{diagram.name}</h3>
          <p className="text-zinc-700 text-sm leading-relaxed mt-1 max-w-2xl">{diagram.summary}</p>
        </div>
        <div className="text-xs font-mono text-zinc-500">
          {diagram.citations.map((c) => <div key={c}>{c}</div>)}
        </div>
      </div>

      <div className="overflow-x-auto -mx-2 px-2 pb-2">
        <svg viewBox={`0 0 ${W} ${H}`} width="100%" style={{ minWidth: 580 }} role="img" aria-label={diagram.name}>
          {/* Background grid */}
          <defs>
            <pattern id={`grid-${diagram.id}`} width="20" height="20" patternUnits="userSpaceOnUse">
              <path d="M 20 0 L 0 0 0 20" fill="none" stroke="#f4f4f5" strokeWidth="1" />
            </pattern>
          </defs>
          <rect width="100%" height="100%" fill={`url(#grid-${diagram.id})`} />

          {/* Riser backbone (vertical SLC line) */}
          <line x1={W - 90} y1={20} x2={W - 90} y2={H - 70} stroke="#dc2626" strokeWidth="2" strokeDasharray="6 3" />
          <text x={W - 84} y={28} fontSize="9" fontFamily="monospace" fill="#dc2626" fontWeight="bold">RISER / SLC</text>

          {/* Floors */}
          {diagram.floors.map((floor, i) => {
            const yTop = 20 + i * FLOOR_H;
            const yMid = yTop + FLOOR_H / 2;
            return (
              <g key={floor.label}>
                {/* Floor band */}
                <line x1={PAD_X} y1={yTop} x2={W - 30} y2={yTop} stroke="#a1a1aa" strokeWidth="1" />
                <text x={PAD_X - 8} y={yMid + 4} fontSize="11" fontFamily="monospace" textAnchor="end" fill="#52525b" fontWeight="bold">{floor.label}</text>
                {/* Horizontal floor wire */}
                <line x1={PAD_X + 8} y1={yMid} x2={W - 90} y2={yMid} stroke="#71717a" strokeWidth="1" />

                {/* Devices */}
                {floor.devices.map((d) => {
                  const dx = PAD_X + 16 + ((W - PAD_X - 130) * d.x) / 100;
                  const isSel = selected?.id === d.id;
                  return (
                    <g
                      key={d.id}
                      onClick={() => setSelected({ ...d, floor: floor.label })}
                      style={{ cursor: "pointer" }}
                      data-testid={`riser-device-${d.id}`}
                    >
                      {/* Drop line from horizontal */}
                      <line x1={dx} y1={yMid} x2={dx} y2={yMid - 14} stroke="#a1a1aa" strokeWidth="1" />
                      <Symbol type={d.type} cx={dx} cy={yMid - 26} active={isSel} />
                      <text x={dx} y={yMid + 14} fontSize="8" fontFamily="monospace" textAnchor="middle" fill="#52525b">{d.label}</text>
                    </g>
                  );
                })}

                {/* Connect floor wire to riser backbone */}
                <line x1={W - 90} y1={yMid} x2={W - 70} y2={yMid} stroke="#dc2626" strokeWidth="1.5" />
              </g>
            );
          })}

          {/* Off-premises */}
          {diagram.offPremises && (
            <g
              onClick={() => setSelected({ id: "off-prem", floor: "Off-premises", type: diagram.offPremises.type, label: diagram.offPremises.label, note: diagram.offPremises.note })}
              style={{ cursor: "pointer" }}
              data-testid="riser-off-premises"
            >
              <line x1={W - 90} y1={H - 70} x2={W - 90} y2={H - 35} stroke="#dc2626" strokeWidth="2" strokeDasharray="3 3" />
              <Symbol type="supervising-station" cx={W - 90} cy={H - 18} active={selected?.id === "off-prem"} />
              <text x={W - 90} y={H - 36} fontSize="8" fontFamily="monospace" textAnchor="middle" fill="#dc2626" fontWeight="bold">DACT/IP</text>
            </g>
          )}
        </svg>
      </div>

      {/* Selected device drawer */}
      {selected && (
        <div className="mt-4 border-2 border-red-200 bg-red-50/40 p-4 flex items-start gap-3" data-testid="riser-selected-detail">
          <div className="w-9 h-9 bg-red-600 text-white grid place-items-center flex-shrink-0">
            <Info className="w-4 h-4" />
          </div>
          <div className="flex-1 min-w-0">
            <div className="font-mono text-[11px] uppercase tracking-widest text-zinc-500 mb-1">{selected.floor} · {selected.type}</div>
            <div className="font-heading text-lg font-bold tracking-tight" data-testid="riser-selected-label">{selected.label}</div>
            {selected.note && <p className="text-sm text-zinc-700 mt-1 leading-relaxed">{selected.note}</p>}
            {selected.lessonId && !freeMode && (
              <Link
                to={`/lesson/${selected.lessonId}`}
                className="inline-flex items-center gap-1.5 text-sm text-red-600 font-semibold mt-2 hover:underline"
                data-testid="riser-lesson-link"
              >
                <BookOpen className="w-3.5 h-3.5" /> Open related lesson →
              </Link>
            )}
            {selected.lessonId && freeMode && (
              <div className="text-xs text-zinc-500 font-mono mt-2">Lesson reference: {selected.lessonId} (paid course)</div>
            )}
          </div>
          <button onClick={() => setSelected(null)} className="text-zinc-500 hover:text-red-600" data-testid="riser-detail-close">
            <X className="w-4 h-4" />
          </button>
        </div>
      )}
    </div>
  );
};

export default RiserDiagram;
